import { ConfirmDialog } from 'components';
import { FormattedMessage } from 'react-intl';

type StatusRollbackDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  statusRollbackPayload: {
    fromLabel: string;
    toLabel: string;
  } | null;
};

const StatusRollbackDialog = ({ open, onClose, onConfirm, statusRollbackPayload }: StatusRollbackDialogProps) => {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      maxWidth="xs"
      title={<FormattedMessage id="effortTracing.statusRollbackConfirmTitle" defaultMessage="Emin misiniz?" />}
      description={
        <>
          <FormattedMessage
            id="effortTracing.statusRollbackConfirmText"
            defaultMessage="Statü geriye alınacak: {from} → {to}. Devam etmek istiyor musunuz?"
            values={{
              from: statusRollbackPayload?.fromLabel ?? '',
              to: statusRollbackPayload?.toLabel ?? '',
            }}
          />
        </>
      }
    />
  );
};

export default StatusRollbackDialog;
